<template>
  <div @click="showCalendlyIntegration">
    <slot>
    </slot>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: { showOnMount: { type: Boolean, default: false } },
  created() {
    this._calendlyRefs = { script: null, css: null }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('tour', ['activeTour']),
  },
  async mounted() {
    if (!document.getElementById('_calendly-style')) {
      const style = document.createElement('link')
      style.id = '_calendly-style'
      style.type = 'text/css'
      style.rel = 'stylesheet'
      style.href = 'https://assets.calendly.com/assets/external/widget.css'
      document.head.appendChild(style)
    }
    if (!document.getElementById('_calendly-script')) {
      const script = document.createElement('script')
      script.id = '_calendly-script'
      script.src = 'https://assets.calendly.com/assets/external/widget.js'
      if (this.showOnMount) script.onload = this.showCalendlyIntegration
      document.head.appendChild(script)
    } else if (this.showOnMount) {
      this.showCalendlyIntegration
    }
  },
  methods: {
    showCalendlyIntegration() {
      if (this.activeTour) return //workaround as event.stopPropagation doesnt seem to work correctly
      if (!window.Calendly) {
        throw new Error(
          'Calendly not active, likely removed by an unmounted instance'
        )
      }
      window.Calendly.showPopupWidget(
        'https://calendly.com/refera/integration-request?hide_landing_page_details=1&hide_gdpr_banner=1',
        'PopupText',
        {
          url:
            'https://calendly.com/refera/integration-request?hide_landing_page_details=1&hide_gdpr_banner=1',
          text: 'Book Integration',
          color: '#519f85',
          buttonColor: '#519f85',
          textColor: '#ffffff',
          branding: false,
          prefill: {
            name: this.user?.first_name + ' ' + this.user?.last_name,
            email: this.user?.practice.email,
          },
        }
      )
    },
  },
  destroyed() {
    //bad, if another instance is using this, it will break - should use a singleton like store to keep track of "consumers"
    // document.getElementById('_calendly-script')?.remove()
    // document.getElementById('_calendly-style')?.remove()
  },
}
</script>

<style>
</style>